export const BREAKPOINTS = {
  mobile: 360,
  tablet: 768,
  desktop: 1280,
}

export const MATCH_MEDIA_QUERIES = {
  mobile: `(max-width: ${BREAKPOINTS.tablet - 1}px)`,
  desktop: `(min-width: ${BREAKPOINTS.desktop}px)`,
  tablet: `(min-width: ${BREAKPOINTS.tablet}px) and (max-width: ${BREAKPOINTS.desktop - 1}px)`,
  small: `(max-width: ${BREAKPOINTS.mobile - 1}px)`,
}

export const SERVER_DATE_FORMAT = `yyyy-MM-dd'T'HH:mm:ss.SSSXXX`

export const DEFAULT_ITEMS_PER_PAGE = 6

export enum AcceptedFileType {
  ARCHIVE = '.zip, .rar, .7z, .tar, .gz, application/x-tar, application/x-compressed, application/x-gtar, application/x-gzip, application/x-7z-compressed, application/x-rar-compressed, application/zip, application/vnd.rar',
  //https://stackoverflow.com/questions/11832930/html-input-file-accept-attribute-file-type-csv#answer-11834872
  SPREADSHEET = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
  DOCS = '.doc, .docx, .rtf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  OPEN_OFFICE_FILE = 'application/vnd.oasis.opendocument.presentation, application/vnd.oasis.opendocument.spreadsheet, application/vnd.oasis.opendocument.text',
  // https://stackoverflow.com/a/12481143
  APPLE_IWORK_FILE = 'application/vnd.apple.pages, application/vnd.apple.keynote, application/vnd.apple.numbers',
  PRESENTATION = '.ppt, .pptx',
  PDF = 'application/pdf, .pdf',
  EMAIL = '.eml, .mbox',
  TEXT = 'text/*, application/xml, application/json',
  IMAGE = 'image/*',
  AUDIO = 'audio/*',
  VIDEO = 'video/*',
}

export const VAT_RATE_DEFAULT = 20
